import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ISetpointModel } from '../shared/models/models';

@Component({
    selector: 'dl-rtu-dialog-buttons',
    template: `
        <!-- Buttons for Set Point Editor view -->
        <cas-button btnClass="md-accent md-raised"
                    *ngIf="!override"
                    (clickAction)="cancelEmitter.emit()"
                    btnText="Cancel"></cas-button>
        <!-- The save button should be available without the form being dirty if we are on a New Setpoint -->
        <cas-button btnClass="md-accent md-raised"
                    *ngIf="!override"
                    (clickAction)="saveEmitter.emit()"
                    [disabled]="(!currentSetpoint.timeRange && !setpointEditorForm.dirty) || setpointEditorForm.invalid"
                    btnText="Save"></cas-button>
    `
})
export class RtuModalButtonsComponent {
    @Input() public override: boolean;
    @Input() public currentSetpoint: ISetpointModel;
    @Input() public setpointEditorForm: FormGroup;

    @Output() public cancelEmitter = new EventEmitter();
    @Output() public saveEmitter = new EventEmitter();
}
